import type {TokenType} from 'micromark-util-types'

import type {Token} from './tokenize/token'

export type CstNodeType = TokenType | 'root'

export interface CstNode {
  type: CstNodeType
  start: number
  end: number
  children: CstNode[]
}

/** Convert a flat token array to a concrete syntax tree. */
export function buildCst(tokens: Token[], sourceLength: number): CstNode {
  const root: CstNode = {type: 'root', start: 0, end: sourceLength, children: []}
  const stack: CstNode[] = [root]

  for (const {direction, ...token} of tokens) {
    if (direction === 'enter') {
      const node: CstNode = {...token, children: []}
      const last = stack.at(-1)
      if (!last) break // should never happen
      last.children.push(node)
      stack.push(node)
    } else {
      stack.pop()
    }
  }

  return root
}
